import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/components/CaseMenuSpeedDial.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/app/app/[locale]/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/TranslationsProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material-nextjs/v13-appRouter/appRouterV13.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/Box/Box.js");
;
import(/* webpackMode: "eager", webpackExports: ["SessionProvider"] */ "/app/node_modules/next-auth/react.js");
